import React, { Fragment } from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";

const backColor = "#3c4087";

Font.register({
  family: "Helvetica",
  fonts: [{ src: "https://fonts.googleapis.com/css2?family=Helvetica-Bold" }],
});
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: backColor,
    borderBottomWidth: 1,
    minHeight: 20,
    maxHeight: 35,
    flexGrow: 1,
    fontSize: "10px",
    alignItems: "center",
  },

  label: {
    width: "40%",
    borderRightColor: backColor,
    textAlign: "left",
    marginRight: 10,
    marginLeft: 10,
    fontFamily: "Helvetica-Bold",
  },
  amount: {
    width: "60%",
    borderRightColor: backColor,
    textAlign: "right",
    marginRight: 10,
    fontFamily: "Helvetica-Bold",
  },
});
export class PayslipBoldRow extends React.Component {
  render() {
    let { value, Label } = this.props;

    return (
      <View style={styles.row}>
        <Text style={styles.label}>{Label ? Label : ""}</Text>
        <Text style={styles.amount}>
          {value ? Number(value).toFixed(2) : ""}
        </Text>
      </View>
    );
  }
}
